module.exports = __webpack_public_path__ + "img/icon-sb-buy-as-a-set-and-save-boutique-48x48.78a1b78.svg";